import React, { useState } from 'react'
import {
  Scheduler,
  SCHEDULER_DEMO_COLUMNS,
  SCHEDULER_DEMO_DATE,
  createSchedulerDemoEvents,
  type SchedulerEvent,
  type SchedulerViewMode,
} from '@components/ui'
import UiPreviewCanvas from '../components/UiPreviewCanvas'
import './SchedulerShowcase.css'

const SchedulerShowcase: React.FC = () => {
  const [date, setDate] = useState(SCHEDULER_DEMO_DATE)
  const [events, setEvents] = useState<SchedulerEvent[]>(() =>
    createSchedulerDemoEvents(SCHEDULER_DEMO_DATE),
  )
  const [viewMode, setViewMode] = useState<SchedulerViewMode>('Fixed')
  const [darkMode, setDarkMode] = useState(false)

  return (
    <UiPreviewCanvas
      title="Scheduler"
      description="Appointment Day, Week, and Month boards with DS Schedule cards and mock Appointment interactions. View mode (Fixed / Full) is settings-driven via prop — same as Settings → System → Scheduler."
      stageClassName="ui-preview__stage--wide scheduler-showcase__stage-wrap"
    >
      <div
        className={`scheduler-showcase__sheet${
          darkMode ? ' scheduler-showcase__sheet--dark' : ''
        }`}
      >
        <section
          className={`ui-showcase-live${
            darkMode ? ' ui-showcase-live--dark' : ''
          }`}
        >
          <div className="scheduler-showcase__live-header">
            <h3 className="ui-showcase-live__title">Live preview</h3>
            <div className="scheduler-showcase__live-controls">
              <label className="scheduler-showcase__control">
                <span>View mode</span>
                <select
                  className="ui-field-control"
                  value={viewMode}
                  onChange={(event) =>
                    setViewMode(event.target.value as SchedulerViewMode)
                  }
                >
                  <option value="Fixed">Fixed</option>
                  <option value="Full">Full</option>
                </select>
              </label>
              <label className="scheduler-showcase__dark-toggle">
                <input
                  type="checkbox"
                  checked={darkMode}
                  onChange={(event) => setDarkMode(event.target.checked)}
                />
                <span>Dark mode</span>
              </label>
            </div>
          </div>
          <div className="scheduler-showcase__live">
            <Scheduler
              columns={SCHEDULER_DEMO_COLUMNS}
              events={events}
              date={date}
              viewMode={viewMode}
              onDateChange={setDate}
              onEventsChange={setEvents}
              enableInteractions
              darkMode={darkMode}
            />
          </div>
        </section>
      </div>
    </UiPreviewCanvas>
  )
}

export default SchedulerShowcase
